import { useParams } from "react-router-dom";

// context
import { CurrentResultProvider } from "../services/context/current-result-context";

// components
import { Results } from "../components/results/results";
import { LoaderMUI } from "../assets/global/loader/loader-mui";
import { AlertMessage } from "../assets/global/alert/alert-message";
import { useAppContext } from "../services/context/app-context";
import { useResultsContext } from "../services/context/results-context";
import { useEffect, useState } from "react";
import { fetchProperty } from "../services/api/site-settings-api";
import { fetchRunners } from "../services/api/results-api";
import {
  fetchBuildings,
  fetchBuildingTypes,
  fetchConnectionTypes,
} from "../services/api/planner-api";

export const ResultsPage = () => {
  const { projectId } = useParams();
  const { setProperty, setPropertyLocation } = useAppContext();
  const { setRunners, setBuildings, setBuildingsTypes, setConnectionTypes } =
    useResultsContext();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* const [runners, setRunners] = useState(null); */
  const [propertyResponse, setPropertyResponse] = useState(null);

  const fetchData = async () => {
    if (!projectId) return;
    setLoading(true);
    setError(null);
    try {
      // Parallel calls
      const [
        fetchedProperty,
        fetchedRunners,
        fetchedBuildings,
        fetchedBuildingTypes,
        fetchedConnectionTypes,
      ] = await Promise.all([
        fetchProperty(projectId),
        fetchRunners(projectId),
        fetchBuildings(projectId),
        fetchBuildingTypes(),
        fetchConnectionTypes(),
      ]);

      if (fetchedProperty && Object.hasOwn(fetchedProperty, "geodata")) {
        const data = fetchedProperty;

        // Convert the geodata to GeoJSON if present
        const propertyGeoData = data.geodata ? JSON.parse(data.geodata) : null;
        const accessGeoJSON = data.access1 ? JSON.parse(data.access1) : null;
        const locationGeoData = data.locationGeodata
          ? JSON.parse(data.locationGeodata)
          : null;
        const coordinates = data.coordinates
          ? [data.coordinates?._longitude, data.coordinates?._latitude]
          : null;

        const propertyGeoJSON = propertyGeoData
          ? {
              type: "FeatureCollection",
              features: [propertyGeoData],
            }
          : null;

        setPropertyLocation(coordinates);
        setProperty({
          location: data.location,
          locationGeodata: locationGeoData,
          propertyGeoJSON: propertyGeoJSON,
          selectedLine: accessGeoJSON,
          area: data.area,
          perimeter: data.perimeter,
          minBorderDistance: data.minBorderDistance,
          maxConstrHeight: data.maxConstrHeight,
          buildingDensity: data.buildingDensity,
          borderWidths: {},
          coordinatesCenter: {
            lat: data.coordinates?._latitude,
            long: data.coordinates?._longitude,
          },
          maxBorder: null,
          propertyArea: fetchedProperty.propertyArea,
        });
        setPropertyResponse({
          location: data.location,
          locationGeodata: locationGeoData,
          propertyGeoJSON: propertyGeoJSON,
          selectedLine: accessGeoJSON,
          area: data.area,
          perimeter: data.perimeter,
          minBorderDistance: data.minBorderDistance,
          maxConstrHeight: data.maxConstrHeight,
          buildingDensity: data.buildingDensity,
          borderWidths: {},
          coordinatesCenter: {
            lat: data.coordinates?._latitude,
            long: data.coordinates?._longitude,
          },
          maxBorder: null,
        });
        setConnectionTypes(fetchedConnectionTypes);
      }

      setRunners(fetchedRunners);
      setBuildings(fetchedBuildings);
      setBuildingsTypes(fetchedBuildingTypes);
      // If you want to do something with property in a parent context
      /* onPropertyLoaded?.(propertyData); */
    } catch (err) {
      console.error("Error fetching data:", err);
      const message =
        err.response?.data?.message || err.message || "Error fetching data";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [projectId]);

  // Loading / Error handling
  if (loading) return <LoaderMUI withBackdrop={true} />;
  if (error) return <AlertMessage message={error} type="error" />;

  return (
    <>
      <CurrentResultProvider>
        {/* Loader */}
        {/* {loading && <LoaderMUI withBackdrop={true} />} */}

        {/* Error Alert */}
        {/* {error && <AlertMessage message={error} type="error" />} */}

        {
          /* !loading && */ <Results
            /* runnerList={runners} */
            projectId={projectId}
            propertyGeoData={propertyResponse?.propertyGeoJSON}
          />
        }
      </CurrentResultProvider>
    </>
  );
};
